import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const couponsApi = createApi({
    reducerPath: 'couponsApi',
    tagTypes: ['coupons'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getCoupons: build.query({
            query: (data) => ({
                url: api.coupons.getCoupons(),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
            providesTags: ['coupons']
        }),
        createCoupon: build.mutation({
            query: (data) => ({
                url: api.coupons.createCoupon(),
                method: 'POST',
                body: data
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(
                        couponsApi.util.updateQueryData('getCoupons', patch, (draft) => {
                            draft.unshift(data)
                        })
                    )
                } catch (error) {
                    console.error('Failed to update cache:', error)
                }
            },
        }),
        updateCoupon: build.mutation({
            query: ({id, ...data}) => ({
                url: api.coupons.updateCoupon(id),
                method: 'PUT',
                body: data
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(
                        couponsApi.util.updateQueryData('getCoupons',  {location_id: patch.location_id} , (draft) => {
                            const itemIndex = draft?.findIndex(item => item.id === patch.id)
                            if (itemIndex !== -1) {
                                draft[itemIndex] = data
                            }
                        })
                    )
                } catch(e) {
                    console.error('Update failed:', e)
                }
            },
        }),
        deleteCoupon: build.mutation({
            query: ({ id }) => ({
                url: api.coupons.deleteCoupon(id),
                method: 'DELETE',
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    dispatch(
                        couponsApi.util.updateQueryData('getCoupons', patch, (draft) => {
                            const index = draft.findIndex((coupon) => coupon.id === patch.id);
                            if (index !== -1) {
                                draft.splice(index, 1)
                            } else {
                                console.warn('Coupon not found in cache')
                            }
                        })
                    );
                } catch (e) {
                    console.error('Delete failed:', e)
                }
            },
        }),
        getCouponHistory: build.query({
            query: ({id, ...data}) => ({
                url: api.coupons.getCouponHistory(id),
                method: 'GET',
                params: data,
            }),
            serializeQueryArgs: ({endpointName, queryArgs}) => {
                return [endpointName, queryArgs?.location_id, queryArgs?.storage_id]
            },
            merge: (currentCache, newItems, {arg}) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({currentArg, previousArg}) => {
                return currentArg !== previousArg;
            },
        }),
    })
})

export const { useLazyGetCouponHistoryQuery, useDeleteCouponMutation } = couponsApi